import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Vuex from 'vuex'
import Vue2Filters from 'vue2-filters'

Vue.use(Vue2Filters)
Vue.use(Vuex)

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ToggleButton from 'vue-js-toggle-button'

Vue.use(ToggleButton)

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/broadcaster/transfer',
    name: 'SeasonPass',
    component: () => import(/* webpackChunkName: "about" */ '../views/BroadcasterTransfer.vue')
  },
  {
    path: '/broadcaster/seasonpass',
    name: 'SeasonPass',
    component: () => import(/* webpackChunkName: "about" */ '../views/PaymentSeasonPass.vue')
  },
  {
    path: '/broadcaster/stripe/connect',
    name: 'SeasonPass',
    component: () => import(/* webpackChunkName: "about" */ '../views/PaymentConnectStripe.vue')
  },
  {
    path: '/viewer/login',
    name: 'Viewer Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/ViewerLogin.vue')
  },
  {
    path: '/viewer/create',
    name: 'Viewer Signup',
    component: () => import(/* webpackChunkName: "about" */ '../views/ViewerCreateAccount.vue')
  },
  {
    path: '/viewer/lock/:channel_id',
    name: 'Viewer Lock',
    component: () => import(/* webpackChunkName: "about" */ '../views/ViewerLock.vue')
  },
  {
    path: '/viewer/payment/complete/:seasonpass_id',
    name: 'Viewer Payment',
    component: () => import(/* webpackChunkName: "about" */ '../views/ViewerAddPayment.vue')
  },
  {
    path: '/viewer/payment/',
    name: 'Viewer List',
    component: () => import(/* webpackChunkName: "about" */ '../views/ViewerSeasonPassList.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
